import { rowHasAudio } from "./row-has-audio";

export const noAudioClientIds = (rows = []) =>
    rows.filter((row) => row?.id && !rowHasAudio(row)).map((row) => row.id);
